import { BulletSeparator } from '@/components/_shared/BulletSeparator';
import styles from '../EventDetails.module.scss';
import type { Venue } from '@/types';
import { FormattedMessage } from 'react-intl';
import { LocationIcon } from '@/components/_shared/Icons/LocationIcon';
import type { ReactNode } from 'react';
import { FollowVenueButton } from './FollowVenueButton';

type EventVenueProps = {
  venue?: Venue;
  isOnline?: boolean;
  showFollowVenueCta?: boolean;
};

type VenueLinkProps = {
  children: ReactNode;
};

const VenueLink = ({ children }: VenueLinkProps) => {
  return (
    <a className={styles.secondaryText} data-testid="event-venue" href="#location">
      <LocationIcon aria-label="Location" className={styles.locationIcon} />
      {children}
    </a>
  );
};

export const EventVenue = ({ venue, isOnline, showFollowVenueCta }: EventVenueProps) => {
  if (isOnline) {
    return (
      <VenueLink>
        <FormattedMessage
          id="Online event"
          defaultMessage="Online event"
          description="Label for online event location"
        />
      </VenueLink>
    );
  }

  if (!venue && !isOnline) {
    return (
      <VenueLink>
        <FormattedMessage
          id="Location TBD"
          defaultMessage="Location TBD"
          description="To display in event venue section when location is TBD"
        />
      </VenueLink>
    );
  }

  if (!venue || !venue.name) {
    return null;
  }

  const addressParts = [venue.address?.city, venue.address?.region].filter(Boolean);
  const addressText = addressParts.join(', ');
  const addressWithSeparator = addressText ? (
    <>
      <BulletSeparator />
      {addressText}
    </>
  ) : null;

  return (
    <div className={styles.venueRow}>
      <VenueLink>
        {venue.name}
        {addressWithSeparator}
      </VenueLink>
      {showFollowVenueCta && (
        <div className={styles.followVenueButtonWrapper}>
          <FollowVenueButton />
        </div>
      )}
    </div>
  );
};
